import { render } from "./AppDesktop.vue?vue&type=template&id=143156b6&scoped=true"
import script from "./AppDesktop.vue?vue&type=script&lang=js"
export * from "./AppDesktop.vue?vue&type=script&lang=js"

import "./AppDesktop.vue?vue&type=style&index=0&id=143156b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143156b6"]])

export default __exports__